import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type TerminateDriverMutationVariables = Types.Exact<{
  driverId: Types.Scalars['bigint']['input'];
}>;


export type TerminateDriverMutation = { __typename?: 'mutation_root', update_drivers?: { __typename?: 'drivers_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'drivers', id: number, status: string, tax_class: string, driver_app_version?: string | null, phone_type?: string | null, user?: { __typename?: 'users', id: number, display_name: string, email?: string | null, phone?: string | null, active: boolean, avatar_url?: string | null } | null }> } | null, update_users?: { __typename?: 'users_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'users', id: number, active: boolean }> } | null };


export const TerminateDriverDocument = gql`
    mutation TerminateDriver($driverId: bigint!) {
  update_drivers(where: {id: {_eq: $driverId}}, _set: {status: "terminated"}) {
    affected_rows
    returning {
      id
      status
      tax_class
      driver_app_version
      phone_type
      user {
        id
        display_name
        email
        phone
        active
        avatar_url
      }
    }
  }
  update_users(where: {driver: {id: {_eq: $driverId}}}, _set: {active: false}) {
    affected_rows
    returning {
      id
      active
    }
  }
}
    `;
export type TerminateDriverMutationFn = Apollo.MutationFunction<TerminateDriverMutation, TerminateDriverMutationVariables>;

/**
 * __useTerminateDriverMutation__
 *
 * To run a mutation, you first call `useTerminateDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTerminateDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [terminateDriverMutation, { data, loading, error }] = useTerminateDriverMutation({
 *   variables: {
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useTerminateDriverMutation(baseOptions?: Apollo.MutationHookOptions<TerminateDriverMutation, TerminateDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TerminateDriverMutation, TerminateDriverMutationVariables>(TerminateDriverDocument, options);
      }
export type TerminateDriverMutationHookResult = ReturnType<typeof useTerminateDriverMutation>;
export type TerminateDriverMutationResult = Apollo.MutationResult<TerminateDriverMutation>;
export type TerminateDriverMutationOptions = Apollo.BaseMutationOptions<TerminateDriverMutation, TerminateDriverMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (update_drivers, update_users): returns the full response object.
 * @source {@link src/features/drivers/queries/terminateDriver.mutation.gql}
 */
export async function terminateDriver(
  variables: TerminateDriverMutationVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<TerminateDriverMutation> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).mutate<TerminateDriverMutation>(
    TerminateDriverDocument,
    variables,
    requestOptions
  )
}